var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tv-player" },
    [
      _vm.getIsTizen
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player", type: "application/avplayer" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getIsLG
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player", type: "application/avplayer" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getLGVersion < "5.0"
        ? _c("video", { staticClass: "tv-player__video" })
        : _vm._e(),
      _vm._v(" "),
      _vm.getIsOrsay
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player", type: "application/avplayer" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.getIsOrsay && !_vm.getIsLG && !_vm.getIsTizen
        ? _c("video", {
            staticClass: "tv-player__video",
            attrs: {
              src: "https://media.digmedia.net/website/video/rain_264.mp4?_=1",
              muted: "",
              autoplay: "",
              loop: ""
            },
            domProps: { muted: true }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showOSD
          ? _c("div", { staticClass: "tv-osd" }, [
              _c("div", { staticClass: "tv-osd__header" }, [
                _c(
                  "div",
                  { staticClass: "tv-osd__header-back" },
                  [
                    _c(
                      "div",
                      { staticClass: "tv-osd__header-app" },
                      [
                        _c(
                          "Icon2",
                          {
                            staticClass: "tv-osd__app-icon",
                            attrs: {
                              color: "#c1c1c1",
                              "icon-name": "WayfinderRadio",
                              height: 96,
                              width: 96
                            }
                          },
                          [_c("WayfinderRadio")],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Icon",
                      {
                        staticClass: "tv-osd__back-icon",
                        class: {
                          "tv-osd__back-icon--active": _vm.isBackButtonActive
                        },
                        attrs: {
                          "icon-name": "WayfinderArrowLeft",
                          color: "#f1f1f1",
                          height: 46,
                          width: 46
                        }
                      },
                      [_c("WayfinderArrowLeft")],
                      1
                    ),
                    _vm._v("\n          " + _vm._s(_vm.getBack) + "\n        ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tv-osd__header-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$store.getters["radio/getChannelHeadline"]) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tv-osd__body" }, [
                _c(
                  "ul",
                  { ref: "listWrapper", staticClass: "tv-osd__channel-list" },
                  _vm._l(_vm.getChannels, function(channel, index) {
                    return _c(
                      "li",
                      {
                        key: "chanel-" + index,
                        ref: "listElements",
                        refInFor: true,
                        staticClass: "channel-list__channel truncate",
                        class: {
                          "channel-list__channel--active":
                            _vm.$store.getters[
                              "radio/getTargetChannelIndex"
                            ] === index && !_vm.isBackButtonActive
                        },
                        style: _vm.getStyleSheetOffset
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(index + 1) +
                            ". " +
                            _vm._s(channel.name) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tv-osd__channel-info" })
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.showOSD && _vm.getActiveChannelName
        ? _c(
            "div",
            { staticClass: "radio-now-playing" },
            [
              _c(
                "Icon2",
                {
                  staticClass: "radio-now-playing__icon",
                  attrs: {
                    color: "#c1c1c1",
                    "icon-name": "WayfinderRadio",
                    height: 56,
                    width: 56
                  }
                },
                [_c("WayfinderRadio")],
                1
              ),
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$store.getters["radio/getChannelHeadline"]) +
                  "\n  "
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84579470", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84579470","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RadioPlayer.vue
// module id = null
// module chunks = 